// @ts-nocheck

import { request } from '../../../context';
import type { ApiOptions } from '../../../context';
import type { BaseResponseListFieldFoundAdvanceWrapperResponse } from '../../../types';

/**
 * 原声管理-筛选器字段
 *
 * @export
 * @tags 字段定义
 * @link [POST] /field/voc/search-template
 */
export function postFieldVocSearchTemplate(): Promise<BaseResponseListFieldFoundAdvanceWrapperResponse>;
export function postFieldVocSearchTemplate(
    options: ApiOptions<never, never>
): Promise<BaseResponseListFieldFoundAdvanceWrapperResponse>;
export function postFieldVocSearchTemplate(
    options?: ApiOptions<never, never>
): Promise<BaseResponseListFieldFoundAdvanceWrapperResponse> {
    return request<never, never, never>('/field/voc/search-template', {
        ...options,
        method: 'post',
        __$requestCalleeName: 'postFieldVocSearchTemplate',
    });
}

export const meta = [{ tags: ['字段定义'], path: '/field/voc/search-template', method: 'post' }];
